import { SelectChangeEvent } from '@mui/material';
import { ControlledSelectCheckmark } from 'Components/ControlledSelectCheckmark';
import { AdvancedSearchContext } from 'Context/MedicalReferralsContext/AdvancedSearchProvider';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary, useIsDesktop } from 'Hooks';
import { ReactNode, useContext } from 'react';

export const ReferralStatus = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.MedicalReferrals);
  const { advancedSearch, dispatchAdvancedSearch } = useContext(
    AdvancedSearchContext
  );
  const isDesktop = useIsDesktop();

  const validationDateOptions = [
    dictionary.search.advancedSearch.options.valid,
    dictionary.search.advancedSearch.options.invalid,
    dictionary.search.advancedSearch.options.future,
  ];

  const dictionaryByRequestValidation: Record<string, string> = {
    presentValidated: dictionary.search.advancedSearch.options.valid,
    futureValidated: dictionary.search.advancedSearch.options.future,
    pastValidated: dictionary.search.advancedSearch.options.invalid,
  };

  const handleOnChange = (
    event: SelectChangeEvent<string[]>,
    child: ReactNode
  ) => {
    const selected = event.target.value as string[];

    const payloadValues = selected.reduce((acc, value) => {
      if (value === dictionary.search.advancedSearch.options.valid) acc.push(1);

      if (value === dictionary.search.advancedSearch.options.invalid)
        acc.push(2);

      if (value === dictionary.search.advancedSearch.options.future)
        acc.push(3);

      return acc;
    }, new Array<number>());

    dispatchAdvancedSearch({
      type: 'REQUEST_DATE_VALIDATION',
      payload: { value: payloadValues },
    });
  };

  const checkmarkedValue = Object.entries(advancedSearch.requestValidation)
    .filter(([value, checked]) => checked)
    .map(([value, checked]) => dictionaryByRequestValidation[value] || '');

  return (
    <ControlledSelectCheckmark
      size={'small'}
      disablePortal={isDesktop ? false : true}
      label={dictionary.search.advancedSearch.accordingToRequestDate}
      options={validationDateOptions}
      selected={checkmarkedValue}
      onChange={handleOnChange}
    />
  );
};
